import type { AnonymousVcsCredentials, GitHubVcsCredentials, PersistenceSettings, ReferenceVcsCredentials, UsernamePasswordVcsCredentials } from "../resources/projectResource";

export interface PlatformHubVersionControlSettingsResource {
    Url: string;
    Credentials: AnonymousVcsCredentials | UsernamePasswordVcsCredentials | ReferenceVcsCredentials | GitHubVcsCredentials;
    DefaultBranch: string;
    BasePath: string;
}

export function isPlatformHubVersionControlSettingsResource(T: PersistenceSettings): T is PlatformHubVersionControlSettingsResource {
    return !("Type" in T);
}
